import type { ExportColumn } from '@app/src/types/export'

export const AllAssessmentsExportColumnsAccessor: ExportColumn[] = [
  {
    translationId: 'export.schemas.provider.company.name',
    exportPath: 'assessmentTemplate.name',
  },
]
